const locale = {
    VehicleVIOReport: "Vehicle VIO -raportti",
    ArticleVIOReport: "Artikkeli VIO -raportti",
    History: "Historia",
    UserManagement: "Käyttäjien hallinta",
    FirstName: "Etunimi",
    Email: "Sähköposti",
    Region: "Alue",
    Year: "vuosi",
    Month: "Kuukausi",
    DownloadDate: "Latauspäivämäärä",
    Type: "Tyyppi"
}

export default locale;